import { Attractor } from "./Attractor";
export async function loadParticlesAttractInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesAttract", (container) => new Attractor(container), refresh);
}
